/**
 * Music player state options.
 * Treat this file as an enum.
 * @module alphaTabPlayerStates
 * @category AlphaTab
 * @author Daniel Griessler <dgriessler20@gmail.com>
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * The music is stopped
 * @type {string}
 */
export const STOPPED = 0;

/**
 * The music is playing
 * @type {string}
 */
export const PLAYING = 1;

/**
 * A stop is pending
 * @type {string}
 */
export const PENDING_STOP = 2;
